module.exports = __webpack_public_path__ + "img/qrcode-app.298eb8fe.jpg";